<style scoped>
.imgSet {
	width: 80%;
}
.download_text{
	text-align: left;
	text-decoration: underline;
}
</style>
<style src="@/assets/css/common.css" scoped></style>
<template>
	<div>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					NetFlow3D Input
				</div>
			</b-row>
			<b-row>
				<b-col cols="12" sm="12" class="text-left">
					We applied NetFlow3D to two independent pan-cancer somatic mutation datasets: The Cancer Genome Atlas (TCGA) and the Catalogue of Somatic Mutations in Cancer (COSMIC). For each dataset, we employed two strategies to map mutations to proteins—one considering only canonical isoforms and the other including all possible isoforms. 
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_input/TCGA_canonical.zip" download>TCGA_canonical.zip</a>
				</b-col>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_input/TCGA_isoform.zip" download>TCGA_isoform.zip</a>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_input/COSMIC_canonical.zip" download>COSMIC_canonical.zip</a>
				</b-col>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_input/COSMIC_isoform.zip" download>COSMIC_isoform.zip</a>
				</b-col>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					NetFlow3D Output
				</div>
			</b-row>
			<b-row>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_output/TCGA_canonical.zip" download>TCGA_canonical.zip</a>
				</b-col>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_output/TCGA_isoform.zip" download>TCGA_isoform.zip</a>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_output/COSMIC_canonical.zip" download>COSMIC_canonical.zip</a>
				</b-col>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/NetFlow3D_output/COSMIC_isoform.zip" download>COSMIC_isoform.zip</a>
				</b-col>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					The Human Protein Structurome
				</div>
			</b-row>
			<b-row>
				<b-col cols="12" sm="12" class="text-left">
					The human protein structurome is available for download from the NetFlow3D GitHub repository: <a href="https://github.com/haiyuan-yu-lab/NetFlow3D?tab=readme-ov-file#the-human-protein-structurome" class="hyper_link">https://github.com/haiyuan-yu-lab/NetFlow3D?tab=readme-ov-file#the-human-protein-structurome</a>.
				</b-col>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					Miscellaneous
				</div>
			</b-row>
			<b-row>
				<b-col cols="6" sm="6" align-self="center" class="download_text">
					<a href="/download/Miscellaneous/FDA_approved_drugs_and_targets.xlsx" download>FDA_approved_drugs_and_their_targets.xlsx</a>
				</b-col>
			</b-row>
		</b-container>
		<br>
		<br>
		<br>
		<br>
	</div>
</template>
<!--<img class="download_icon" src="@/assets/images/Download1.png" /> -->
<script>

export default {
	components: {
	},
	created() {
		//localStorage.clear();
	},
	mounted() {},
	methods: {
	},
};
</script>

